import { useEffect, useState } from "react";
import { requester } from "api/pesabackend";
import { useSelector } from "react-redux";
import usePaginatedBillingList from "./paginatedList";

const resource_tag = "billing";

const useGetInvoicesList = (pageNumber, business_branch_id) => {
  const {
    rows,
    count,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    refresh,
  } = usePaginatedBillingList({
    path: `/${resource_tag}/invoices`,
    business_branch_id,
    externalRefresh: pageNumber,
  });

  const setNewItemData = (value) => {
    if (value) refresh();
  };

  return {
    invoicesList: rows,
    count,
    isLoadingInvoicesList: loading,
    isLoadingMore: loadingMore,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    errorInvoicesList: error,
    setNewItemData,
    refresh,
  };
};

const useGetCustomerInvoicesList = (pageNumber, business_branch_id) => {
  const {
    rows,
    count,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
  } = usePaginatedBillingList({
    path: `/${resource_tag}/invoices/customer`,
    business_branch_id,
    externalRefresh: pageNumber,
  });

  return {
    invoicesList: rows,
    count,
    isLoadingInvoicesList: loading,
    isLoadingMore: loadingMore,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    errorInvoicesList: error,
  };
};

const useGetReceiptsList = (pageNumber, business_branch_id) => {
  const refreshCount = useSelector((state) => state.authReducer.refreshCount);

  const {
    rows,
    count,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
  } = usePaginatedBillingList({
    path: `/${resource_tag}/receipts`,
    business_branch_id,
    externalRefresh: refreshCount,
  });

  return {
    receiptsList: rows,
    count,
    isLoadingReceiptsList: loading,
    isLoadingMore: loadingMore,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    errorReceiptsList: error,
  };
};

const useGetPaymentTypesList = (pageNumber, business_branch_id) => {
  const refreshCount = useSelector((state) => state.authReducer.refreshCount);
  const [paymentTypesList, setPaymentTypesList] = useState([]);
  const [isLoadingPaymentTypesList, setLoadingPaymentTypesList] = useState(true);
  const [errorPaymentTypesList, setErrorPaymentTypesList] = useState(false);

  const url = `/${resource_tag}/payment_types?search=False&business_branch=${business_branch_id}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await requester.get(url);
        setPaymentTypesList(response.data.data);
        setLoadingPaymentTypesList(false);
        setErrorPaymentTypesList(false);
      } catch {
        setErrorPaymentTypesList(true);
        setLoadingPaymentTypesList(false);
      }
    };
    fetchData();
  }, [refreshCount, url]);

  return { paymentTypesList, isLoadingPaymentTypesList, errorPaymentTypesList };
};

const useGetRefundsList = (pageNumber, business_branch_id) => {
  const refreshCount = useSelector((state) => state.authReducer.refreshCount);

  const {
    rows,
    count,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    refresh,
  } = usePaginatedBillingList({
    path: `/${resource_tag}/refunds`,
    business_branch_id,
    externalRefresh: refreshCount,
  });

  const setNewReturnData = (value) => {
    if (value) refresh();
  };

  return {
    refundsList: rows,
    count,
    isLoadingRefundsList: loading,
    isLoadingMore: loadingMore,
    hasMore,
    loadMore,
    dateFilter,
    setDateFilter,
    customRange,
    setCustomRange,
    applyCustomRange,
    errorRefundsList: error,
    setNewReturnData,
    refresh,
  };
};

export {
  useGetInvoicesList,
  useGetReceiptsList,
  useGetPaymentTypesList,
  useGetRefundsList,
  useGetCustomerInvoicesList,
};
